<template>
  <div>
    <the-header :is-mobile="isMobile" />

    <main class="main">
      <div class="page">
        <div class="page__content">
          <div class="container">
            <div class="row">
              <div class="col col-xl-0 col-lg-2" v-if="!isMobile && userId">
                <main-menu />
              </div>

              <div
                class="col col-xs-12 col-lg-9 col-xxl-7"
                :class="{ 'col-lg-offset-2': !userId }"
              >
                <router-view />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader.vue';
import MainMenu from '@/components/MainMenu.vue';

import { DESKTOP_SIZE } from '@/settings.js';
import { GET_DESCRIPTION } from '@/store/mutationTypes.js';

export default {
  name: 'Page',
  components: {
    TheHeader,
    MainMenu,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= DESKTOP_SIZE;
    },
    getDescriptions() {
      this.$store.dispatch(GET_DESCRIPTION, { key: 'activityType' });
      this.$store.dispatch(GET_DESCRIPTION, { key: 'socialNetworkType' });
      this.$store.dispatch(GET_DESCRIPTION, { key: 'activityCVLevel' });
      this.$store.dispatch(GET_DESCRIPTION, { key: 'skillLevel' });
    },
  },
  created() {
    const { userId } = this;

    if (userId) {
      this.getDescriptions();
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    });
  },
  beforeDestroy() {
    window.addEventListener('resize', this.handleResize);
  },
  watch: {
    userId(newVal) {
      if (newVal) {
        this.getDescriptions();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/shared/_globals.scss';

.page {
  $page: &;

  min-height: calc(100vh - var(--header-height--mobile));
  box-sizing: border-box;

  padding-top: var(--global-dimension-size-400);
  padding-bottom: var(--global-dimension-size-1000);

  background-color: var(--color-gray-100);
  color: var(--color-gray-900);

  @include from('xl') {
    min-height: calc(100vh - var(--header-height));
  }

  &__title {
    margin: 0 0 var(--global-dimension-size-400);
    font-weight: var(--global-font-weight-bold);
    font-size: var(--font-size-800);
    line-height: var(--global-dimension-size-500);
  }

  &__subtitle {
    margin: var(--global-dimension-size-300) 0 var(--global-dimension-size-100);
    font-weight: var(--global-font-weight-bold);
    font-size: var(--global-dimension-size-300);
    line-height: var(--global-dimension-size-300);
  }

  &__section {
    & + & {
      margin-top: var(--global-dimension-size-400);
    }
  }
}

.main {
  padding-top: var(--header-height--mobile);

  @include from('xl') {
    padding-top: var(--header-height);
  }
}
</style>
